import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";

import { PropertyValidationDocument } from "../validation-documents/validation-document.schema";
import { documentsBasicSchema } from "./documentsBasic.schema";
import locationStepSchema from "./locationStep.schema";
import descriptionStepSchema from "./descriptionStep.schema";
import seoStepSchema from "./seoStep.schema";
import multimediaSepSchema from "./multimediaStep.schema";
import projectStepSchema from "./projectStep.schema";
import { boolean, InferType, mixed, string } from "@yup";
import { object } from "@yup";

const propertyFields = {
  id_property: mixed().default("").label("Id de propiedad"),
  draft_id: mixed().default("").label("Id de borrador"),
  is_edit: boolean().default(false).label("Indicador de edición"),
  is_project: boolean()
    .label("Indicador de tipo de proyecto")
    .required("Indicador de tipo de proyecto es requerido")
    .default(false),
  instructions_ia: string().default(""),
  ...locationStepSchema,
  ...descriptionStepSchema,
  ...seoStepSchema,
  ...multimediaSepSchema,
  ...projectStepSchema,
  ...documentsBasicSchema,
  ...PropertyValidationDocument
};

const PropertyFormSchema = object(propertyFields);
const CPropertyForm = PropertyFormSchema.getDefault();
const CPropertyFormKeys = HGetKeyEnums(CPropertyForm) as {
  [K in keyof typeof CPropertyForm]: K;
};
export type IPropertyForm = InferType<typeof PropertyFormSchema>;
export { CPropertyForm, CPropertyFormKeys, PropertyFormSchema };

export const keysIndicatorsObject = {
  location: [...Object.keys(locationStepSchema), CPropertyFormKeys.type_property],
  description: [
    ...Object.keys(descriptionStepSchema),
    ...Object.keys(seoStepSchema)
  ],
  document: [
    ...Object.keys(documentsBasicSchema),
    ...Object.keys(PropertyValidationDocument),
    // Only observe specific building subfields used in MxCatchmentTable
    `${CPropertyFormKeys.building}.name`,
    `${CPropertyFormKeys.building}.unitsQuantity`,
    `${CPropertyFormKeys.building}.dateDelivery`,
    `${CPropertyFormKeys.building}.isCaptured`
  ],
  multimedia: [...Object.keys(multimediaSepSchema)],
  buildings: [...Object.keys(projectStepSchema), CPropertyFormKeys.type_property],
  minimalFieldToGenerateSeo: [
    CPropertyFormKeys.city_property,
    CPropertyFormKeys.sector_property,
    CPropertyFormKeys.meter_construction_property,
    CPropertyFormKeys.meter_land_property,
    CPropertyFormKeys.business_types_property,
    CPropertyFormKeys.bedrooms_property,
    CPropertyFormKeys.bathrooms_property,
    CPropertyFormKeys.half_bathrooms_property,
    CPropertyFormKeys.parking_spots_property,
    CPropertyFormKeys.total_floor_property,
    CPropertyFormKeys.level_floor_property
  ],
  seoFieldsRequiredToTranslate: [
    CPropertyFormKeys.seo_title_es_property,
    CPropertyFormKeys.seo_short_description_es_property,
    CPropertyFormKeys.seo_description_es_property,
    CPropertyFormKeys.seo_keywords_es_property
  ],

  seoBuilderFieldChecker: [
    CPropertyFormKeys.seo_title_en_property,
    CPropertyFormKeys.seo_short_description_en_property,
    CPropertyFormKeys.seo_description_en_property,
    CPropertyFormKeys.seo_keywords_en_property,
    CPropertyFormKeys.seo_title_es_property,
    CPropertyFormKeys.seo_short_description_es_property,
    CPropertyFormKeys.seo_description_es_property,
    CPropertyFormKeys.seo_keywords_es_property
  ]
};
